import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * step 1) 댓글 등록, (목록, 작성자별) 조회, 수정, 삭제
 */

/**
 * 댓글 등록
 * @param param
 * board_id
 * influencer_id
 * category_type
 * phone
 * password
 * content
 * is_secret
 * is_alert
 * created_by : user.id
 * is_influencer: for admin
 * @returns {Promise<*>}
 */
const createComment = async (param) => {
	const { data } = await axios.post(`${baseUrl}/partners/leave/comment`, param);
	return data;
};

/**
 * 댓글 목록 조회
 * @param param
 * offset, pagSize
 * influencerId
 * boardId
 * pageType
 * userId: 로그인 cUser.id, 비로그인 0/null
 * @returns {Promise<never>}
 */
const readComment = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/partners/read/category/commentList`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 댓글 작성자별 조회
 * @param param
 * offset, pageSize
 * influencerId,
 * boardId,
 * pageType,
 * phone,
 * password
 * @returns {Promise<never>}
 */
const readCommentByUser = async (param) => {
	const { data } = await axios.get(`${baseUrl}/partners/read/commentList`, {
		params: param,
	});
	return data;
};

/**
 * 댓글 수정
 * @param param
 * id, content, is_secret, updated_by
 * @returns {Promise<*>}
 * 200
 * 998 : 비밀번호 일치 x
 * 400 : Not Found Data
 * 406 : Failed To Edit
 */
const updateComment = async (param) => {
	const { data } = await axios.post(`${baseUrl}/partners/edit/comment`, param);
	return data;
};

/**
 * 댓글 삭제
 * @param param
 * commentId, userId
 * @returns {Promise<*>}
 * 200
 * 998 : 비밀번호 일치 x
 * 400 : Not Found Data
 * 406 : Failed To Edit
 */
const deleteComment = async (param) => {
	const { data } = await axios.delete(`${baseUrl}/partners/delete/comment`, {
		params: param,
	});
	return data;
};

/**
 * step 2) 답글 등록, 조회, 수정, 삭제
 */

/**
 * 답글 등록 (*관리자)
 * @param param
 * comment_id*
 * phone, password, content*, is_secret*
 * created_by*
 * is_influencer: false : 인플루언서일 경우 true
 * @returns {Promise<*>}
 */
const createReply = async (param) => {
	const { data } = await axios.post(
		`${baseUrl}/partners/create/replyByComment`,
		param
	);
	return data;
};

/**
 * 답글 수정
 * @param param
 * id, phone, password, content, is_secret
 * @returns {Promise<*>}
 * 200
 * 998 : 비밀번호 일치 x
 * 400 : Not Found Data
 * 406 : Failed To Edit
 */
const updateReply = async (param) => {
	const { data } = await axios.post(`${baseUrl}/partners/edit/reply`, param);
	return data;
};

/**
 * 답글 삭제
 * @param param
 * replyId, userId
 * @returns {Promise<*>}
 * 200
 * 998 : 비밀번호 일치 x
 * 400 : Not Found Data
 * 406 : Failed To Edit
 */
const deleteReply = async (param) => {
	const { data } = await axios.delete(`${baseUrl}/partners/delete/reply`, {
		params: param,
	});
	return data;
};

/**
 * 댓글, 답글 유효성 검사
 * @param param
 * commentId : 댓글
 * replyId : 답글
 * phone, password
 * @returns {Promise<never>}
 */
const validCommentReply = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/partners/valid/commentAndReply`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 관리자 댓글/답글 목록 조회
 * @param param
 * offset, pageSize,
 * influencerId,
 * answerStatus
 * searchWord
 * @returns {Promise<never>}
 */
const adminReadComment = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/partners/read/admin/commentList`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 관리자 답글 수정
 * @param param
 * id
 * comment_id
 * content
 * is_secret
 * updated_by
 * @returns {Promise<*>}
 * 수정한 답글 개수
 */
const adminUpdateReply = async (param) => {
	const { data } = await axios.post(
		`${baseUrl}/partners/edit/admin/reply`,
		param
	);
	return data;
};

/**
 * 관리자 댓글 삭제
 * @param param
 * commentId, userId
 * @returns {Promise<*>}
 * 200
 * 999 : 회원가입한 사용자가 아닙니다
 * 406 : Failed To Edit
 */
const adminDeleteComment = async (param) => {
	const { data } = await axios.delete(
		`${baseUrl}/partners/delete/admin/comment`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * 관리자 답글 삭제
 * @param param
 * replyId, userId
 * @returns {Promise<*>}
 * 200
 * 999 : 회원가입한 사용자가 아닙니다
 * 406 : Failed To Edit
 */
const adminDeleteReply = async (param) => {
	const { data } = await axios.delete(
		`${baseUrl}/partners/delete/admin/reply`,
		{
			params: param,
		}
	);
	return data;
};

/**
 * channel-user 가져오기
 * @param param
 * @returns {Promise<never>}
 */
const getCUserByUserId = async (param) => {
	const { data } = await axios.get(`${baseUrl}/partners/read/userInfo`, {
		params: param,
	});
	return data;
};

/**
 * 댓글/답글 등록/수정 -> 이미지 등록/수정/삭제
 * @param param
 * target_id: comment_id,reply_id
 * target_type
 * created_by
 * imageList: [
 *  { title, img_type }
 * ]
 * @returns {Promise<*>}
 */
const postCommentImage = async (param) => {
	const { data } = await axios.post(
		`${baseUrl}/partners/register/comment/image`,
		param
	);
	return data;
};

const commentApi = {
	createComment,
	readComment,
	readCommentByUser,
	updateComment,
	deleteComment,

	createReply,
	updateReply,
	deleteReply,

	validCommentReply,

	adminReadComment,
	adminUpdateReply,
	adminDeleteComment,
	adminDeleteReply,

	getCUserByUserId,
	postCommentImage,
};

export default commentApi;
